import { createSlice } from '@reduxjs/toolkit';
import {
  fetchPayouts,
  updatePayouts,
  fetchTotalCredits,
} from '../thunks/payouts';

const initialState = {
  payouts: [],
  totalCredits: null,
  fetching: false,
  fetchError: '',
  saving: false,
  saveError: '',
  pageNumber: 1,
  perPage: 20,
};

export const payoutsSlice = createSlice({
  name: 'payouts',
  initialState,
  reducers: {
    setPayoutsPageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },
  },
  extraReducers: {
    [fetchPayouts.pending]: (state) => {
      state.fetching = true;
    },
    [fetchPayouts.fulfilled]: (state, action) => {
      state.fetching = false;
      if (state.pageNumber === 1) {
        state.payouts = action.payload;
      } else {
        state.payouts = [...state.payouts, ...action.payload];
      }
    },
    [fetchPayouts.rejected]: (state, action) => {
      state.fetching = false;
      state.fetchError = action.payload.error;
    },
    [updatePayouts.pending]: (state) => {
      state.fetching = true;
    },
    [updatePayouts.fulfilled]: (state, action) => {
      state.fetching = false;
      const updatedPayouts = state.payouts.map((payout) => {
        if (payout.id === action.payload.id) {
          return action.payload;
        } else {
          return payout;
        }
      });

      state.payouts = updatedPayouts;
    },
    [updatePayouts.rejected]: (state, action) => {
      state.fetching = false;
      state.fetchError = action.payload.error;
    },
    [fetchTotalCredits.pending]: (state) => {
      state.fetching = true;
    },
    [fetchTotalCredits.fulfilled]: (state, action) => {
      state.fetching = false;
      state.totalCredits = action.payload;
    },
    [fetchTotalCredits.rejected]: (state, action) => {
      state.fetching = false;
      state.fetchError = action.payload.error;
    },
  },
});

export const { setPayoutsPageNumber } = payoutsSlice.actions;
